<script setup lang="ts">
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useLessonRecurringSchedule } from '../../model/lessons/lesson-recurring-schedule.hook'

defineOptions({
  name: 'LessonRecurringControls',
})

const {
  refSubmitText,
  refIsSubmitting,
  refLessonsUrl,
  submit,
} = useLessonRecurringSchedule()
</script>

<template>
  <div class="lesson-recurring-controls">
    <BtnSecondary
      text="Go back"
      color="black"
      :to="refLessonsUrl"
    />
    <BtnPrimary
      :text="refSubmitText"
      color="emerald"
      :disabled="refIsSubmitting"
      @click="submit"
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonRecurringControls.scss" />
